import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ColumnMode, SortType } from '@swimlane/ngx-datatable';
import { DataService } from 'src/app/data.service';

@Component({
  selector: 'app-dokumentumaim',
  templateUrl: './dokumentumaim.component.html',
  styleUrls: ['./dokumentumaim.component.scss'],
})
export class DokumentumaimComponent implements OnInit {
  protected readonly ColumnMode = ColumnMode;
  protected readonly SortType = SortType;

  sajatIntezmeny: any;
  user$: any;
  dokumentumok: any[] = [];
  betoltes = false;

  /** Tanulói (vagy volt tanulói) belépés: a saját dokumentumait látja, nem a gyermekeiét. */
  tanulo = false;
  /** Megszűnt jogviszony (backend: /user-tanulo volt_tanulo) – korlátozott mód, 80 éves hozzáférés. */
  voltTanulo = false;
  jogviszonyVege: string | null = null;
  megorzesVege: string | null = null;

  // A backend `tipus` mezőjének emberi felirata.
  private readonly tipusLabel: { [k: string]: string } = {
    bizonyitvany: 'Bizonyítvány',
    bizonyitvany_masodlat: 'Bizonyítványmásodlat',
    hatarozat: 'Határozat',
    kerveny: 'Kérvény',
    beadvany: 'Beadvány',
  };

  constructor(private http: HttpClient, private data: DataService) {}

  async ngOnInit() {
    this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    this.user$ = await this.data.getFromStorage('user');
    const loginmode = await this.data.getFromStorage('loginmode');
    const meta: any = await this.data.getFromStorage('userMetadata');
    this.tanulo = loginmode === 'tanulo';
    this.voltTanulo = this.tanulo && Number(meta?.volt_tanulo) === 1;
    this.jogviszonyVege = this.voltTanulo ? (meta?.jogviszony_vege || null) : null;
    this.megorzesVege = this.voltTanulo ? (meta?.megorzes_vege || null) : null;
    this.loadDokumentumok();
  }

  tipusNev(tipus: string): string {
    return this.tipusLabel[tipus] || (tipus || 'Dokumentum');
  }

  loadDokumentumok() {
    const intezmeny = String(this.sajatIntezmeny?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    /*  TANULÓ: a saját dokumentumai a kiszolgálón a belépésből (tokenből) dőlnek el – nem
     *  küldünk nevet. A gondviselő a gyermekei dokumentumait a szülői végponton kéri. */
    let url: string;
    if (this.tanulo) {
      url = '/api/dokumentumok/tanulo';
    } else {
      const username = this.user$?.username;
      if (!username) return;
      url = '/api/dokumentumok/szulo/' + username + '/' + intezmeny;
    }
    this.betoltes = true;
    this.http
      .get<any>(url)
      .subscribe({
        next: (lista) => {
          this.betoltes = false;
          this.dokumentumok = Array.isArray(lista) ? lista : [];
        },
        error: (e) => {
          this.betoltes = false;
          console.error('Dokumentumok betöltési hiba:', e);
          this.data.sendToast('Nem sikerült betölteni a dokumentumokat.', 'error');
        },
      });
  }
}
